export default __webpack_public_path__ + "static/media/Rephrase.da62ab98.png";